import type { PayloadAction } from '@reduxjs/toolkit';
import type { ActionType, InitialStateType } from './types';

const defaultActionState = {
  loading: false,
  loadingMessage: '',
  error: false,
  errorMessage: '',
  success: false,
  successMessage: '',
  showMessage: false,
};

const reducers = {
  setLoadingState: (
    state: InitialStateType,
    action: PayloadAction<{ actionType: ActionType; loading: boolean; message: string }>,
  ) => {
    const { actionType, loading, message } = action.payload;

    if (!state[actionType]) {
      state[actionType] = {};
    }

    state[actionType] = {
      ...state[actionType],
      loading,
      loadingMessage: message,
    };
  },

  setErrorState: (
    state: InitialStateType,
    action: PayloadAction<{ actionType: ActionType; message: string }>,
  ) => {
    const { actionType, message } = action.payload;

    if (!state[actionType]) {
      state[actionType] = {};
    }

    state[actionType] = {
      ...state[actionType],
      loading: false,
      success: false,
      successMessage: '',
      errorMessage: message,
    };
  },

  setSuccessState: (
    state: InitialStateType,
    action: PayloadAction<{ actionType: ActionType; message: string }>,
  ) => {
    const { actionType, message } = action.payload;

    if (!state[actionType]) {
      state[actionType] = {};
    }

    state[actionType] = {
      ...state[actionType],
      loading: false,
      success: true,
      successMessage: message,
      errorMessage: '',
    };
  },

  setShowMessageState: (
    state: InitialStateType,
    action: PayloadAction<{ actionType: ActionType; show: boolean }>,
  ) => {
    const { actionType, show } = action.payload;

    if (!state[actionType]) {
      state[actionType] = {};
    }

    state[actionType] = {
      ...state[actionType],
      showMessage: show,
    };
  },

  resetActionState: (
    state: InitialStateType,
    action: PayloadAction<{ actionType: ActionType }>,
  ) => {
    const { actionType } = action.payload;

    state[actionType] = { ...defaultActionState };
  },

  setInitializedState: (
    state: InitialStateType,
    action: PayloadAction<{ actionType: ActionType; initialized: boolean }>,
  ) => {
    const { actionType, initialized } = action.payload;

    if (!state[actionType]) {
      state[actionType] = {};
    }

    state[actionType] = {
      ...state[actionType],
      initialized,
    };
  },
};

export default reducers;
